<template>
  <v-card class="mx-6 mt-6 banner__ai" flat>
    <div class="hide-mobile">
      <img src="@/assets/techLines.svg" />
    </div>
    <div class="d-flex container__title">
      <img src="@/assets/pandaChip.svg" class="hide-mobile mr-4" />
      <div class="d-flex flex-column mr-md-9">
        <span class="text-h6 font-weight-medium white--text">{{
          $i18next.t('message.banners.ai.title')
        }}</span>
        <span class="subtitle white--text font-weight-regular">{{
          $i18next.t('message.banners.ai.subtitle')
        }}</span>
      </div>
      <div class="d-flex align-end">
        <div class="mb-md-1 mt-md-0 mt-2">
          <BaseBtn
            type="tertiary"
            @click="openArticle"
            class="bg-dark--ignore"
            >{{ $i18next.t('message.banners.ai.action') }}</BaseBtn
          >
        </div>
      </div>
    </div>
    <div class="hide-mobile">
      <img src="@/assets/techLines.svg" class="mirror" />
    </div>
    <div class="close-banner">
      <v-icon color="white" size="20px" @click="handleClose">mdi-close</v-icon>
    </div>
  </v-card>
</template>

<script>
import BaseBtn from '@/components/BaseBtn.vue'
import Storage from '@/utils/Storage'

export default {
  name: 'AiBanner',
  components: { BaseBtn },
  computed: {
    locale() {
      return this.$i18next.resolvedLanguage
    },
  },
  methods: {
    openArticle() {
      const links = {
        pt: 'https://help.pandavideo.com/pt-br/article/como-funciona-nossa-inteligencia-artificial-1gly8ci/',
        en: 'https://help.pandavideo.com/en-us/article/how-does-our-artificial-intelligence-work-1rsoar/',
      }
      window.open(links[this.locale], '_blank')
    },
    handleClose() {
      Storage.setItem('hasClosedAiBanner', true)
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
.close-banner {
  position: absolute;
  right: 8px;
  top: 4px;
}

.banner__ai {
  min-height: 90px;
  height: 90px;
  border-radius: 4px;
  background: linear-gradient(93deg, #3f4ff7 13.31%, #5211dd 67.78%), #a0acff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0px;
}

.mirror {
  -webkit-transform: scaleX(-1) scaleY(-1);
  transform: scaleX(-1) scaleY(-1);
}

.subtitle {
  font-size: 18px;
  color: #e1dbff;
}

.page-view {
  &__container.has-pre-content {
    grid-template-areas: 'header-mobile' 'pre-content' 'content' 'header' !important;
    grid-template-rows: auto auto 1fr auto !important;

    @media (min-width: 680px) {
      grid-template-areas: 'header' 'pre-content' 'content' !important;
      grid-template-rows: auto auto 1fr !important;
    }
  }
}

.page-view__container.c.has-pre-content,
.page-view__container.ac.has-pre-content {
  grid-template-rows: 75px auto calc(100vh - 189px) !important;
}

@media screen and (max-width: 1279px) {
  .hide-mobile {
    display: none !important;
  }

  .banner__ai {
    justify-content: center;
  }
}

@media screen and (max-width: 982px) {
  .container__title {
    flex-direction: column;
  }

  .page-view__container.c.has-pre-content,
  .page-view__container.ac.has-pre-content {
    grid-template-rows: 75px auto calc(100vh - 249px) !important;
  }

  .banner__ai {
    height: unset;
  }
}

@media screen and (max-width: 679px) {
  .page-view__container.c.has-pre-content,
  .page-view__container.ac.has-pre-content {
    grid-template-rows: auto auto 1fr auto !important;
  }
}

@media screen and (max-width: 572px) {
  .banner__ai {
    padding: 20px 20px;
  }
}
</style>
